import {useState,useEffect} from 'react'
import { getobj } from '../../apicall/apicall'

import { Box } from '@mui/material'
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { TableRow } from "@mui/material";

export default function CustomerStat(props) {
    const [stats,setstat]=useState()
    const[loader,setloader]=useState(true)
    const [refresh]=useState(false)

    useEffect(()=>{
        const url =  process.env.REACT_APP_ZEWA_URL + "device/stat/" + props.id + "/";
        const res = getobj(url)
        res.then(function(res){
            setstat(res)
            setloader(false)
        })

    },[refresh, props.id])

  return (
    <div>
           {loader? <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt='loading...'/>:
        <Box>
            {stats?
              <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableBody>
                  <TableRow>
                    <TableCell><b>Bluetooth Devices</b></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell> Active Devices: </TableCell>{" "}
                    <TableCell>{stats.ble_active}</TableCell>
                   
                  </TableRow>
                  <TableRow>
                    <TableCell>Inactive Devices: </TableCell>
                    <TableCell>
                      {stats.ble_inactive}
                    </TableCell>
                    
                  </TableRow>
                  <TableRow>
                    <TableCell><b>Cellular Devices</b></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Active Devices: </TableCell>
                    <TableCell>{stats.cellular_active}</TableCell>
                    
                  </TableRow>
                  <TableRow>
                    <TableCell>Inactive Devices: </TableCell>
                    <TableCell>{stats.cellular_inactive}</TableCell>
                    
                  </TableRow>
                  <TableRow>
                    <TableCell><b>Hubs</b></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Active Hubs: </TableCell>
                    <TableCell>{stats.hub_active}</TableCell>
                    
                  </TableRow>
                  <TableRow>
                    <TableCell>Inactive Hubs:  </TableCell>
                    <TableCell>{stats.hub_inactive}</TableCell>
                   
                    
                  </TableRow>
                  <TableRow>
                  <TableCell>Bluetooth Devices associated with Hubs: </TableCell>
                  <TableCell>{stats.hub_device}</TableCell>
                    
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            :"No Data available"
            }
        </Box> }
    </div>
  )
}
